import { Box, Container, Grid, Paper, Typography } from '@mui/material';

export function AdmissionProcess({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const steps = Array.isArray(data.admission_process) ? data.admission_process : [];

  if (steps.length === 0) return null;

  return (
    <Box id="admissions" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 7 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              JOIN OUR SCHOOL
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            Simple 4-Step Admission Process
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Follow these easy steps to enroll your child for the upcoming academic session.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {steps.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3.5,
                  height: '100%',
                  borderRadius: 4,
                  backgroundColor: '#ffffff',
                  border: '1px solid #e2e8f0',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                    borderColor: primaryColor,
                  },
                }}
              >
                <Typography
                  variant="h2"
                  fontWeight={900}
                  sx={{
                    color: `${primaryColor}20`,
                    fontSize: '3.5rem',
                    lineHeight: 1,
                    mb: 1,
                  }}
                >
                  {item.step || `0${index + 1}`}
                </Typography>
                <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ mb: 1 }}>
                  {item.title}
                </Typography>
                {item.description && (
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    {item.description}
                  </Typography>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default AdmissionProcess;
